import React from 'react'
import { Navbar, Footer } from '../../components';
import News from './news/News';

export default function Publications() {
  return (
    <div className='emas__publications'>
      <Navbar />
      <News />
      <Footer />
    </div>
  )
}
